import axios from 'axios'
import CONFIG from '../config'

export const login = (roll_no, dob) => {
    let Domain = window.location.hostname
    let isAkTheDomain = Domain.includes('akthedashboard');
    let exam_type= "ANTHE";
    if(isAkTheDomain) {
        exam_type= "AKTHE";
    }
    let data = { roll_number: roll_no, date_of_birth: dob }
    let config = {
        method: 'post',
        url: CONFIG.LOGIN_API+'?exam_type='+exam_type,
        headers: {
            'Content-Type': 'application/json',
        },
        data: data,
    }
    return axios(config)
}
export const dashboard = (token) => {
    let config = {
        method: 'get',
        url: CONFIG.DASHBOARD_API,
        headers: {
            'Content-Type': 'application/json',
            token: token,
        },
    }
    return axios(config)
}

export const mockPayment = (token, url) => {
    let config = {
        method: 'get',
        url,
        headers: {
            'Content-Type': 'application/json',
            token: token,
        },
    }
    return axios(config)
}

export const examInfo = (token) => {
    let config = {
        method: 'get',
        url: CONFIG.EXAM_INFO_API,
        headers: {
            'Content-Type': 'application/json',
            token: token,
        },
    }
    return axios(config)
}
export const editDetails = (token) => {
    let Domain = window.location.hostname
    let isAkTheDomain = Domain.includes('akthedashboard');
    let exam_type= "ANTHE";
    if(isAkTheDomain) {
        exam_type= "AKTHE";
    }
    let config = {
        method: 'get',
        url: CONFIG.MASTER_API+`?exam_type=`+exam_type,
        headers: {
            'Content-Type': 'application/json',
            token: token,
        },
    }
    return axios(config)
}
export const examDates = (token, data) => {
    let config = {
        method: 'post',
        url: CONFIG.EXAM_DATES_API,
        headers: {
            'Content-Type': 'application/json',
            token: token,
        },
        data: data,
    }
    return axios(config)
}
export const generateOTP = (token) => {
    let config = {
        method: 'post',
        url: CONFIG.GENERATE_OTP_API,
        headers: {
            'Content-Type': 'application/json',
            token: token,
        },
    }
    return axios(config)
}
export const validateOTP = (token, otp) => {
    let config = {
        method: 'post',
        url: CONFIG.VALIDATE_OTP_API,
        headers: {
            'Content-Type': 'application/json',
            token: token,
        },
        data: { otp: otp },
    }
    return axios(config)
}
export const updateExamInfo = (token, data) => {
    let config = {
        method: 'post',
        url: CONFIG.UPDATE_EXAM_INFO_API,
        headers: {
            'Content-Type': 'application/json',
            token: token,
        },
        data: data,
    }
    return axios(config)
}
export const startMainExam = (token, shortCode, source_type) => {
    let config = {
        method: 'post',
        url: CONFIG.START_MAIN_EXAM_API,
        headers: {
            'Content-Type': 'application/json',
            token: token,
        },
        data: { test_short_code: shortCode, source_type },
    }
    return axios(config)
}
export const resetSampleExam = (token, shortCode) => {
    let config = {
        method: 'post',
        url: CONFIG.RESET_SAMPLE_EXAM_API,
        headers: {
            'Content-Type': 'application/json',
            token: token,
        },
        data: { test_short_code: shortCode },
    }
    return axios(config)
}

export const result = (body) => {
    let config = {
        method: 'post',
        url: CONFIG.RESULT_API,
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
    }
    return axios(config)
}

export const iacstResult = (body) => {
    let config = {
        method: 'post',
        url: CONFIG.IACST_RESULT_API,
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Basic YXBpX2FkbWluX2Fha2FzaDpBYWthc2hAMTIzIyE=',
        },
        data: body,
    }
    return axios(config)
}
export const forgotPassword = (roll_number) => {
    let config = {
        method: 'post',
        url: CONFIG.FORGOT_PASSWORD,
        headers: {
            'Content-Type': 'application/json',
        },
        data: {
            roll_number: roll_number,
        },
    }
    return axios(config)
}

export const coursePurchase = (body) => {
    let config = {
        method: 'post',
        url: CONFIG.COURSE_PAYMENT_API,
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Basic a3VuYWxfYXBpOkFha2FzaEAxMjMhIw==',
        },
        data: body,
    }
    return axios(config)
}

export const courseListing = (params) => {
    let config = {
        method: 'get',
        url: CONFIG.FETCH_COURSE_DATA + `/${params}`,
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Basic a3VuYWxfYXBpOkFha2FzaEAxMjMhIw==',
        },
    }
    return axios(config)
}

export const getPincode = (params) => {
    let config = {
        method: 'get',
        url: CONFIG.PINCODE_API + `/${params}`,
        headers: {
            'Content-Type': 'application/json',
        },
    }
    return axios(config)
}

export const getState = () => {
    let config = {
        method: 'get',
        url: CONFIG.STATE_API,
        headers: {
            'Content-Type': 'application/json',
        },
    }
    return axios(config)
}

export const getUserGeoInfo = () => {
    let config = {
        method: 'get',
        url: `https://api.ipdata.co/?api-key=${CONFIG.IP_INFO_API_KEY}&fields=ip,city,region,region_cde,country_name,country_code,latitude,longitude,postal`,
        headers: { 'Content-Type': 'application/json' }
    }

    return axios(config)
}

export const getUserCityPincode = (lat, long) => {
    if (!lat || !long) {
        return new Promise((resolve, reject) => { reject("Invalid latitude or longitude") })
    }

    let config = {
        method: 'get',
        url: `https://api.leptonmaps.com/v1/detect/pincode?latitude=${lat}&longitude=${long}`,
        headers: {
            'Content-Type': 'application/json',
            "x-api-key": CONFIG.LEPTON_MAP_API_KEY
        }
    }

    return axios(config)
}

export const getUserSociety = (lat, long) => {
    if (!lat || !long) {
        return new Promise((resolve, reject) => { reject("Invalid latitude or longitude") })
    }

    let config = {
        method: 'get',
        url: `https://api.leptonmaps.com/v1/detect/society?latitude=${lat}&longitude=${long}`,
        headers: {
            'Content-Type': 'application/json',
            "x-api-key": CONFIG.LEPTON_MAP_API_KEY
        }
    }

    return axios(config)
}


export const getCenterPaymentGatewayList = (
    token,
    branchCode,
    examType
) => {
    let config = {
        method: 'get',
        url: `${CONFIG.CENTER_PAYMENT_GATEWAY_API}?branch_code=${branchCode}&exam_type=${examType}`,
        headers: {
            'Content-Type': 'application/json',
            token: token,
        },
    }

    return axios(config)
}

export const examUrlTP = (body, token) => {
    let config = {
        method: 'post',
        url: CONFIG.TP_URL_LINK,
        headers: {
            'Content-Type': 'application/json',
            token: token,
            'Access-Control-Allow-Headers': '*',
        },
        data: body,
    }

    return axios(config)
}